/**
 * Parse Explore Unknown mission depth + easy (pacifier) mission count for leaderboards.
 * @param {number | null | undefined} missions
 * @param {number | null | undefined} easyCount
 * @returns {{ missionNum: number, easyNum: number } | null}
 */
export function parseExploreUnknownMissionDepth(missions, easyCount) {
  if (missions == null) {
    return null;
  }
  const missionNum = Number(missions);
  if (!Number.isFinite(missionNum)) {
    throw new Error(`parseExploreUnknownMissionDepth: invalid missions (${String(missions)})`);
  }
  const easyNum = Number(easyCount);
  if (!Number.isFinite(easyNum) || easyNum < 0) {
    throw new Error(`parseExploreUnknownMissionDepth: invalid easyCount (${String(easyCount)})`);
  }
  return { missionNum, easyNum };
}
